export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "period_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner une période"])},
        "with_subject_unpaid_bill": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relevés bloqués"])},
        "with_subject_unpaid_bill_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relevés non inclus dans l'export des virements parce que le magasin a une facture impayée."])}
      },
      "en": {
        "period_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a period"])},
        "with_subject_unpaid_bill": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blocked statements"])},
        "with_subject_unpaid_bill_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statements left out of the transfer export because the store owes an unpaid bill."])}
      }
    }
  })
}
